'use client';
import Image from 'next/image';
import CloseX from '@/public/images/Close_X.svg';

export default function DiscountBanner(props) {
  const { setShowDiscountBanner } = props;

  return (
    <>
      <div
        data-cy="discount-banner"
        className={`discount-banner sh11 fixed z-70 flex h-12.5 max-h-12.5 w-screen items-center justify-center bg-[#9BFF9B] px-1 text-center text-sm whitespace-nowrap transition-opacity duration-100 sm:text-base lg:px-10`}
      >
        <p className={`inline-block whitespace-normal`}>
          Your discount will be <br className="lg:hidden" /> automatically
          applied at checkout.
        </p>
        <div
          className={`absolute top-1 right-2 lg:relative lg:right-0 lg:ml-4 lg:inline-block`}
        >
          <button
            aria-label="Close discount banner"
            onClick={() => setShowDiscountBanner(false)}
          >
            <Image
              src={CloseX.src}
              alt="Close"
              height={CloseX.height}
              width={CloseX.width}
            />
          </button>
        </div>
      </div>
    </>
  );
}
